// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2rJpm","itemTitle":"ClientEmergencyInfo_itemTitle__3jHFo","itemText":"ClientEmergencyInfo_itemText__14yS9"};